import { render, staticRenderFns } from "./SizeList.vue?vue&type=template&id=580e372c"
import script from "./SizeList.vue?vue&type=script&lang=js"
export * from "./SizeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports